// This hook returns the previous value of the value that was passed in.
// It is useful for detecting changes in values in useEffect hooks.

import { useRef } from 'react';

interface RefValue<T> {
  value: T;
  prev: T | null;
}

export const usePrevious = <T>(value: T): T | null => {
  const ref = useRef<RefValue<T>>({
    value: value,
    prev: null,
  });

  const current = ref.current.value;

  if (value !== current) {
    ref.current = {
      value: value,
      prev: current,
    };
  }

  return ref.current.prev;
};
